export default "__VITE_ASSET__DQsIauFW__"